import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { FC, SyntheticEvent, useCallback, useState } from 'react';
import {
  MdAlarmOff,
  MdAlarmOn,
  MdCampaign,
  MdMoreVert as MoreVert,
  MdPolicy,
  MdTableRows,
} from 'react-icons/md';
import {
  setModalAction,
  setModalRemoveSnooze,
  setModalUpdateExpiredAt,
  setSelectedExclusion,
} from '../store-actions/exclusions-store-actions';
import { Exclusion, ExclusionTypeRaw } from '../types/exclusion-types';
import { ReactComponent as OxIcon } from '../../assets/icons/ox-icon.svg';
import OxMenuControlled from '../../elements/OxMenu/OxMenuControlled';

const ExclusionsOptionsMenu: FC<
  React.PropsWithChildren<ExclusionsOptionsMenuProps>
> = ({ exclusion }) => {
  const [open, setOpen] = useState(false);

  const handleRemoveExclusion = useCallback(() => {
    setModalAction(true);
  }, []);

  const handleMakeAppRelevantAlways = useCallback(() => {
    setModalAction(true);
  }, []);

  const handleMakeAppRelevantDefault = useCallback(() => {
    setModalAction(true);
  }, []);

  const handleUpdateExpireDate = useCallback(() => {
    setModalUpdateExpiredAt(true);
  }, []);

  const handleRemoveExpireDate = useCallback(() => {
    setModalRemoveSnooze(true);
  }, []);

  const handleOpenMenu = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      setSelectedExclusion(exclusion);
      setOpen(true);
    },
    [exclusion],
  );

  const handleCloseMenu = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <OxMenuControlled
      onClose={handleCloseMenu}
      open={open}
      trigger={
        <IconButton size='small' onClick={handleOpenMenu}>
          <MoreVert />
        </IconButton>
      }>
      <div>
        <MenuItem
          onClick={handleRemoveExclusion}
          disabled={exclusion.exclusionType !== ExclusionTypeRaw.alert}>
          <ListItemIcon>{<MdCampaign size='1rem' />}</ListItemIcon>
          <ListItemText>Remove Exclusion</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleMakeAppRelevantAlways}
          disabled={exclusion.exclusionType !== ExclusionTypeRaw.application}>
          <ListItemIcon>{<MdTableRows size='1rem' />}</ListItemIcon>
          <ListItemText>Make App Relevant: Always</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleMakeAppRelevantDefault}
          disabled={exclusion.exclusionType !== ExclusionTypeRaw.application}>
          <ListItemIcon>{<OxIcon />}</ListItemIcon>
          <ListItemText>Make App Relevant: Ox Dynamic</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleRemoveExclusion}
          disabled={exclusion.exclusionType !== ExclusionTypeRaw.policy}>
          <ListItemIcon>{<MdPolicy size='1rem' />}</ListItemIcon>
          <ListItemText>Enable Policy</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleUpdateExpireDate}
          disabled={
            exclusion.exclusionType &&
            (exclusion.exclusionType === ExclusionTypeRaw.application ||
              exclusion.exclusionType === ExclusionTypeRaw.policy)
          }>
          <ListItemIcon>{<MdAlarmOn size='1rem' />}</ListItemIcon>
          <ListItemText>Update Exclusion Expiry Date</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleRemoveExpireDate}
          disabled={exclusion.expiredAt === null || !exclusion.isActive}>
          <ListItemIcon>{<MdAlarmOff size='1rem' />}</ListItemIcon>
          <ListItemText>Remove Snooze</ListItemText>
        </MenuItem>
      </div>
    </OxMenuControlled>
  );
};

export interface ExclusionsOptionsMenuProps {
  exclusion: Exclusion;
}

export default ExclusionsOptionsMenu;
